import React, { useCallback, useMemo } from 'react';
import { Button } from '../../../Button';
import styled from 'styled-components';
import { InfoBox } from '../../../InfoBox';
import { useDataTableQuickReportsContext } from '../../utils/DataTableQuickReportsContext';
import { useDataTableQuickActionsContext } from '../../utils/DataTableQuickActionsContext';
import { useIntlUds } from '../../../../translations/UdsIntlProvider';
import { getActiveQuickReport } from '../DataTableQuickReports/utils/QuickReports.utils';

interface Props {
  onQuickReportDrawerOpen(): void;
}

export const DataTableActiveQuickReportSummary = ({ onQuickReportDrawerOpen }: Props) => {
  const { unSavedQuickReport, activeQuickReportId, quickReports, setQuickReportDrawer } =
    useDataTableQuickReportsContext();
  const { undoChanges } = useDataTableQuickActionsContext();
  const hasUnSavedQuickReport = !!unSavedQuickReport;
  const { intl, format } = useIntlUds();

  const activeQuickReportName = useMemo(
    () => getActiveQuickReport(quickReports, activeQuickReportId)?.name ?? '',
    [activeQuickReportId, quickReports]
  );

  const goToQuickReportPanel = useCallback(() => {
    onQuickReportDrawerOpen();
    setQuickReportDrawer(true);
  }, [onQuickReportDrawerOpen, setQuickReportDrawer]);

  return (
    <>
      {!hasUnSavedQuickReport && !!activeQuickReportId && (
        <StyledInfoBox
          actions={
            <Button dataTest="manage-button" color="primary" onClick={goToQuickReportPanel}>
              {intl.DataTable.Filters.Content.quickViewSelected.manageBtn}
            </Button>
          }
          dataTest="manage-quick-reports"
          type="INFO"
          title={format(intl.DataTable.Filters.Content.quickViewSelected.title, { activeQuickReportName })}
        />
      )}
      {hasUnSavedQuickReport && (
        <StyledInfoBox
          actions={
            <Button dataTest="undo-changes-button" color="primary" onClick={undoChanges}>
              {intl.DataTable.Filters.Content.unSavedQuickView.undoBtn}
            </Button>
          }
          dataTest="un-saved-quick-reports-warning"
          type="ALERT"
          title={intl.DataTable.Filters.Content.unSavedQuickView.title}
        />
      )}
    </>
  );
};

const StyledInfoBox = styled(InfoBox)`
  margin-top: 0;
  margin-bottom: ${({ theme }) => theme.spacingSize.l};
`;
